import Objdict from "objdict"
import Unit from "@frog/source/models/Unit.js"

function isEqual(x, y) {
    if(!x && !y) return true
    if(x && y && typeof x === "object" && typeof y === "object") {
        return Object.keys(x).concat(Object.keys(y)).every(key => isEqual(x[key], y[key]))
    }
    return (x === y)
}

export default class Delta {
    static copyDeltastageSum(oldSum) {
        const newSum = {}
        oldSum = oldSum || {}
        Object.keys(oldSum).forEach((key) => {
            if(key == "dialogue") {
                newSum.dialogue = Object.assign({}, oldSum.dialogue)
                return
            }
            if(key == "flags") {
                newSum.flags = Object.assign({}, oldSum.flags)
                return
            }
            if(key == "player") {
                newSum.player = {}
                newSum.player.score = oldSum.player.score
                newSum.player.affiliation = oldSum.player.affiliation
                newSum.player.inventory = Object.assign({}, oldSum.player.inventory)
                return
            }
            if(key == "units") {
                newSum.units = {}
                Object.keys(oldSum.units).forEach((unitKey) => {
                    if(oldSum.units[unitKey] == undefined) return // andrew added
                    newSum.units[unitKey] = {}
                    Object.keys(oldSum.units[unitKey]).forEach((key) => {
                        if(key == "inventory") {
                            newSum.units[unitKey][key] = {}
                            Object.keys(oldSum.units[unitKey][key]).forEach((subkey) => {
                                newSum.units[unitKey][key][subkey] = Object.assign({}, oldSum.units[unitKey][key][subkey])
                            })
                        } else if(key == "energy") {
                            newSum.units[unitKey][key] = {}
                            Object.keys(oldSum.units[unitKey][key]).forEach((subkey) => {
                                newSum.units[unitKey][key][subkey] = oldSum.units[unitKey][key][subkey]
                            })
                        } else if(key == "effects" || key == "position") {
                            newSum.units[unitKey][key] = Object.assign({}, oldSum.units[unitKey][key])
                        } else {
                            newSum.units[unitKey][key] = oldSum.units[unitKey][key]
                        }
                    })
                })
                return
            }
            newSum[key] = oldSum[key]
        })
        return newSum
    }
    static addDeltastages(runningSum, newDeltas) {
        if(newDeltas instanceof Array == false) {
            newDeltas = [newDeltas]
        }
        newDeltas.forEach((newDelta) => {
            if(newDelta == undefined) return
            if(newDelta instanceof Array == true) {
                newDelta.forEach((subnewDelta) => {
                    Delta.addDeltastages(runningSum, subnewDelta)
                })
                return
            }
            Object.keys(newDelta).forEach((key) => {
                if(newDelta[key] instanceof Function) return
                if(key == "mark" || key == "motion" || key == "timing" || key == "func" || key == "audiomix" || key == "audio" || key == "intent") return
                if(key == "deltastages") {
                    newDelta.deltastages.forEach((subnewDelta) => {
                        Delta.addDeltastages(runningSum, subnewDelta)
                    })
                    return
                }
                if(key == "position" || key == "key") {
                    // console.log("trying to enter unit property as delta", newDeltas, newDelta)
                    return
                }
                if(key == "flag" || key == "flags") {
                    let flags = newDelta.flags || {}
                    if(newDelta.flag != undefined) {
                        flags[newDelta.flag.key] = newDelta.flag.value
                    }
                    runningSum.flags = Objdict.merge(runningSum.flags || {}, flags)
                    return
                }
                if(key == "player") {
                    runningSum.player = newDelta.player
                    runningSum.player.inventory = Objdict.merge(runningSum.player.inventory || {}, newDelta.player.inventory)
                    return
                }
                // if it's not one of the above merges, nor a deltaunit
                // then it's an absolute set and we're safe to nuke the old values
                if(key != "units" && key != "unit" && key != "stage") {
                    runningSum[key] = newDelta[key]
                    return
                }

                runningSum.units = runningSum.units || {}
                let newDeltaunits
                if(key == "units") {
                    newDeltaunits = newDelta.units
                } else if(key == "stage") {
                    newDeltaunits = newDelta.stage.units
                } else if(key == "unit") {
                    newDeltaunits = {}
                    newDeltaunits[newDelta.unit.key] = newDelta.unit
                }

                Objdict.forEach(newDeltaunits, (deltaunit, unitKey) => {
                    if(deltaunit == undefined) {
                        runningSum.units[unitKey] = undefined
                        return
                    }
                    runningSum.units[unitKey] = runningSum.units[unitKey] || {}
                    Object.keys(deltaunit).forEach((unitPropertyKey) => {
                        if(unitPropertyKey == "energy") {
                            runningSum.units[unitKey].energy = Objdict.merge(runningSum.units[unitKey].energy || {}, deltaunit.energy)
                            return
                        }
                        if(unitPropertyKey == "inventory") {
                            runningSum.units[unitKey].inventory = runningSum.units[unitKey].inventory || {}
                            runningSum.units[unitKey].inventory.count = runningSum.units[unitKey].inventory.count + deltaunit.inventory.count
                            runningSum.units[unitKey].inventory.items = Objdict.merge(runningSum.units[unitKey].inventory.items || {}, deltaunit.inventory.items)
                            return
                        }
                        if(unitPropertyKey == "effects") {
                            runningSum.units[unitKey].effects = Objdict.merge(runningSum.units[unitKey].effects || {}, deltaunit.effects)
                            return
                        }
                        if(unitPropertyKey == "position") {
                            runningSum.units[unitKey].position = runningSum.units[unitKey].position || {}
                            runningSum.units[unitKey].position.mode = "absolute"
                            if(deltaunit.position.x !== undefined) {
                                runningSum.units[unitKey].position.x = deltaunit.position.x
                            }
                            if(deltaunit.position.y !== undefined) {
                                runningSum.units[unitKey].position.y = deltaunit.position.y
                            }
                            if(deltaunit.position.z !== undefined) {
                                runningSum.units[unitKey].position.z = deltaunit.position.z
                            }
                            //console.log("summed position", unitKey, runningSum.units[unitKey].position)
                            return
                        }
                        runningSum.units[unitKey][unitPropertyKey] = deltaunit[unitPropertyKey]
                    })
                })
            })
        })
    }
    static diffDeltastageSums(a, b) {
        const diff = {}
        const keys = Object.keys(a).concat(Object.keys(b))
        keys.forEach((key) => {
            if(key == "intent" || key == "type" || key == "text" || key == "dialogue") return
            if(key == "flags") {
                diff[key] = {}
                const aProp = a[key] || {}
                const bProp = b[key] || {}
                const propKeys = Object.keys(aProp).concat(Object.keys(bProp))
                propKeys.forEach((subkey) => {
                    if(aProp[subkey] == undefined || bProp[subkey] == undefined) {
                        if(aProp[subkey] == bProp[subkey]) return
                        diff[key][subkey] = {"a": aProp[subkey], "b": bProp[subkey]}
                        return
                    }
                    if(aProp[subkey] != bProp[subkey]) diff[key][subkey] = {"a": aProp[subkey], "b": bProp[subkey]}
                })
                if(Object.keys(diff[key]).length == 0) delete diff[key]
            } else if(key == "player") {
                diff.player = {}
                if(a.player.score != b.player.score) diff.player.score = {"a": a.player.score, "b": b.player.score}
                if(a.player.affiliation != b.player.affiliation) diff.player.affiliation = {"a": a.player.affiliation, "b": b.player.affiliation}
                diff.player.inventory = {}
                const inventoryKeys = Object.keys(a.player.inventory).concat(Object.keys(b.player.inventory))
                inventoryKeys.forEach((subkey) => {
                    if(a.player.inventory[subkey] != b.player.inventory[subkey]) diff.player.inventory[subkey] = {"a": a.player.inventory[subkey], "b": b.player.inventory[subkey]}
                })
                if(Object.keys(diff.player.inventory).length == 0) delete diff.player.inventory
                if(Object.keys(diff.player).length == 0) delete diff.player
            } else if(key == "units") {
                diff[key] = {}
                const unitsKeys = Object.keys(a[key] || {}).concat(Object.keys(b[key] || {}))
                unitsKeys.forEach((unitKey) => {
                    diff.units[unitKey] = {}
                    const diffUnit = diff.units[unitKey]
                    const aUnit = a.units[unitKey]
                    const bUnit = b.units[unitKey]
                    if(aUnit == undefined || bUnit == undefined) {
                        diff.units[unitKey] = {"a": aUnit, "b": bUnit}
                        return
                    }
                    const unitKeys = Object.keys(aUnit).concat(Object.keys(bUnit))
                    unitKeys.forEach((propKey) => {
                        if(aUnit[propKey] == undefined || bUnit[propKey] == undefined) {
                            diffUnit[propKey] = {"a": aUnit[propKey], "b": bUnit[propKey]}
                            return
                        }
                        if(isEqual(aUnit[propKey], bUnit[propKey]) == false) diffUnit[propKey] = {"a": aUnit[propKey], "b": bUnit[propKey]}
                    })
                    if(Object.keys(diffUnit).length == 0) delete diff.units[unitKey]
                })
                if(Object.keys(diff[key]).length == 0) delete diff[key]
            } else {
                if(isEqual(a[key], b[key]) == false) diff[key] = {"a": a[key], "b": b[key]}
            }
        })

        return diff
    }
    static compareDeltastageSums(a, b) {
        return Object.values(Delta.diffDeltastageSums(a, b)).length > 0
    }
    static editUnit(stage, unit, deltaunit, {isAbsolute} = {}) {
        if(isAbsolute == true) {
            if(deltaunit.health !== undefined) {
                unit.health = deltaunit.health
                unit.health = Math.max(unit.health, 0)
            }
            if(deltaunit.armor !== undefined) {
                unit.armor = deltaunit.armor
                unit.armor = Math.min(unit.armor, unit.maxarmor)
                unit.armor = Math.max(unit.armor, 0)
            }
        } else {
            if(deltaunit.health !== undefined) {
                unit.health += deltaunit.health
                unit.health = Math.max(unit.health, 0)
            }
            if(deltaunit.armor !== undefined) {
                unit.armor += deltaunit.armor
                unit.armor = Math.min(unit.armor, unit.maxhealth)
                unit.armor = Math.max(unit.armor, 0)
            }
        }
        if(deltaunit.canBetray != undefined) {
            unit.canBetray = deltaunit.canBetray
        }
        if(deltaunit.isLockedIn != undefined) {
            unit.isLockedIn = deltaunit.isLockedIn
        }
        if(deltaunit.rollingIndex != undefined) { // DICE
            unit.rollingIndex = deltaunit.rollingIndex
        }
        if(deltaunit.attacktype != undefined) {
            unit.attacktype = deltaunit.attacktype
        }
        if(deltaunit.attackrange != undefined) {
            unit.attackrange = deltaunit.attackrange
        }
        if(deltaunit.experience != undefined) {
            unit.experience = deltaunit.experience
        }
        if(deltaunit.number !== undefined) {
            unit.number = deltaunit.number
        }
        if(deltaunit.maxexperience != undefined) {
            unit.maxexperience = deltaunit.maxexperience
        }
        if(deltaunit.properties != undefined) {
            unit.properties = deltaunit.properties // this fully replaces, no add or remove
        }
        if(deltaunit.color != undefined) {
            unit.color = deltaunit.color
        }
        if(deltaunit.element != undefined) {
            unit.element = deltaunit.element
        }
        if(deltaunit.title != undefined) {
            unit.title = deltaunit.title
        }
        if(deltaunit.role != undefined) {
            unit.role = deltaunit.role
        }
        if(deltaunit.image != undefined) {
            unit.image = deltaunit.image
        }
        if(deltaunit.sprites != undefined) {
            unit.sprites = deltaunit.sprites
        }
        if(deltaunit.mode != undefined) {
            unit.mode = deltaunit.mode
        }
        if(deltaunit.maxhealth != undefined) {
            unit.maxhealth = deltaunit.maxhealth
        }
        if(deltaunit.moverange != undefined) {
            unit.moverange = deltaunit.moverange
        }
        if(deltaunit.defense != undefined) {
            unit.defense = deltaunit.defense
        }
        if(deltaunit.power != undefined) {
            unit.power = deltaunit.power
        }
        if(deltaunit.level != undefined) {
            unit.level = deltaunit.level
        }
        if(deltaunit.score != undefined) {
            unit.score = deltaunit.score
        }
        if(deltaunit.faceKey != undefined) {
            unit.faceKey = deltaunit.faceKey
        }
        if(deltaunit.bodyKey != undefined) {
            unit.bodyKey = deltaunit.bodyKey
        }
        if(deltaunit.imageKey != undefined) {
            unit.imageKey = deltaunit.imageKey
        }
        if(deltaunit.portraitKey != undefined) {
            unit.portraitKey = deltaunit.portraitKey
        }
        if(deltaunit.decalImageKey != undefined) {
            unit.decalImageKey = deltaunit.decalImageKey
        }
        if(deltaunit.weaponImageKey !== undefined) {
            unit.weaponImageKey = deltaunit.weaponImageKey
        }
        if(deltaunit.ai !== undefined) {
            unit.ai = deltaunit.ai // just completely replaces it, no merging
        }
        if(deltaunit.direction != undefined) {
            unit.direction = {}
            unit.direction.x = deltaunit.direction.x ?? 0
            unit.direction.y = deltaunit.direction.y ?? 0
        }
        if(deltaunit.state != undefined) {
            unit.state = deltaunit.state
        }
        if(deltaunit.isDead != undefined) {
            unit.isDead = deltaunit.isDead
        }
        if(deltaunit.deathTimer != undefined) {
            unit.deathTimer = deltaunit.deathTimer
        }
        if(deltaunit.isRemoved !== undefined) {
            unit.isRemoved = deltaunit.isRemoved
        }
        if(deltaunit.spriteKey != undefined) {
            unit.spriteKey = deltaunit.spriteKey
        }
        if(deltaunit.position != undefined) {
            if(isAbsolute == true
            || deltaunit.position.mode == "absolute") {
                if(deltaunit.position.x !== undefined) {
                    unit.position.x = deltaunit.position.x
                }
                if(deltaunit.position.y !== undefined) {
                    unit.position.y = deltaunit.position.y
                }
                if(deltaunit.position.z !== undefined) {
                    unit.position.z = deltaunit.position.z
                }
            } else {
                unit.position.x += deltaunit.position.x || 0
                unit.position.y += deltaunit.position.y || 0
                unit.position.z += deltaunit.position.z || 0
            }
            // TODO: RE-CALCULATE TRAP ZONES?? OR CANCEL
            // POSITIONING-BASED EFFECTS LIKE BIND??
        }
        if(deltaunit.energy != undefined) {
            Object.keys(deltaunit.energy).forEach((key) => {
                if(deltaunit.energy[key] != undefined) {
                    unit.energy[key] = deltaunit.energy[key]
                }
            })
        }
        if(deltaunit.effects != undefined) {
            Objdict.forEach(deltaunit.effects, (effect, effectKey) => {
                effectKey = effect?.key ?? effectKey
                if(effect == undefined) {
                    delete unit.effects[effectKey]
                } else if(unit.effects[effectKey] == undefined) {
                    unit.effects[effectKey] = effect
                } else {
                    unit.effects[effectKey] = Objdict.merge(unit.effects[effectKey], effect)
                }
            })
        }
        if(deltaunit.inventory != undefined) {
            if(deltaunit.inventory.count != undefined) {
                unit.inventory.count += deltaunit.inventory.count
            }
            if(deltaunit.inventory.items != undefined) {
                Objdict.forEach(deltaunit.inventory.items, (item, key) => {
                    if(item == undefined) {
                        delete unit.inventory.items[key]
                    } else {
                        unit.inventory.items[key] = item
                    }
                })
            }
        }
        if(deltaunit.equippedItem !== undefined) {
            if(deltaunit.equippedItem == null) {
                delete unit.equippedItem
            } else {
                unit.equippedItem = deltaunit.equippedItem
            }
        }
        if(deltaunit.primaryItem !== undefined) {
            if(deltaunit.primaryItem == null) {
                delete unit.primaryItem
            } else {
                unit.primaryItem = deltaunit.primaryItem
            }
        }
        if(deltaunit.item !== undefined) {
            if(deltaunit.item == null) {
                delete unit.item
            }
            unit.item = deltaunit.item
        }
        if(deltaunit.affiliation != undefined) {
            unit.affiliation = deltaunit.affiliation
        }
        if(deltaunit.nextAffiliation != undefined) {
            unit.nextAffiliation = deltaunit.nextAffiliation
        }
        return unit
    }
    static editStage(stage, deltastages) {
        if(deltastages instanceof Array == false) {
            deltastages = [deltastages]
        }
        deltastages.forEach((deltastage) => {
            if(deltastage == undefined) {
                return
            }

            // DELTA SCHEMA v2 - now supports just .unit to shortcut .units[unitKey]
            if(deltastage.unit != undefined) {
                deltastage.stage = {"unit": deltastage.unit} // TODO DEPRECATE THIS!!
            }
            if(deltastage.units != undefined) {
                deltastage.stage = {"units": deltastage.units}
            }

            if(deltastage.stage != undefined) {
                let deltaunits = deltastage.stage.units
                if(deltaunits == undefined
                && deltastage.stage.unit) {
                    deltaunits = [deltastage.stage.unit]
                }

                Objdict.forEach(deltaunits, (deltaunit, unitKey) => {
                    if(deltaunit == undefined) {
                        delete stage.units[unitKey]
                        return
                    }
                    if(stage.units[deltaunit.key || unitKey] == undefined) {
                        if(deltaunit.key == undefined) {
                            const numberedNewUnits = Object.keys(stage.units).filter((key) => key.startsWith("newUnit")).map((key) => parseInt(key.split("newUnit")[1])).sort((a,b) => a - b)
                            deltaunit.key = "newUnit" + ((numberedNewUnits[numberedNewUnits.length - 1] + 1) || 0)
                        }
                        stage.units[deltaunit.key] = Unit.instantiate({"unit": deltaunit, "random": stage.random})
                        return
                    }
                    Delta.editUnit(stage, stage.units[deltaunit.key || unitKey], deltaunit, {"isAbsolute": true})
                })

                return
            }
            if(deltastage.phase !== undefined) {
                stage.phase = deltastage.phase
            }
            if(deltastage.timeout !== undefined) {
                stage.timeout = deltastage.timeout
            }
            if(deltastage.player !== undefined) {
                if(deltastage.player.inventory !== undefined) {
                    if(deltastage.player.inventory.items != undefined) {
                        Objdict.forEach(deltastage.player.inventory.items, (item, key) => {
                            if(item == undefined) {
                                delete stage.player.inventory.items[key]
                            } else {
                                stage.player.inventory.items[key] = item
                            }
                        })
                    }
                }
                if(deltastage.player.phase != undefined) {
                    stage.player.phase = deltastage.player.phase
                }
                if(deltastage.player.zoomout != undefined) {
                    stage.player.zoomout = deltastage.player.zoomout
                }
                // TODO: player.party
                // TODO: player.day?
                if(deltastage.player.score !== undefined) {
                    stage.player.score = deltastage.player.score
                }
                if(deltastage.player.affiliation !== undefined) {
                    stage.player.affiliation = deltastage.player.affiliation
                }
                if(deltastage.player.rollcount !== undefined) {
                    stage.player.rollcount = deltastage.player.rollcount
                }
            }
            if(deltastage.camera !== undefined) {
                stage.camera = deltastage.camera
            }
            if(deltastage.dialogue !== undefined) {
                stage.dialogue = stage.dialogue || {}
                stage.dialogue.text = deltastage.dialogue.text
                stage.dialogue.index = deltastage.dialogue.index
                // stage.dialogue.speakingCharacter = deltastage.dialogue.speakingCharacter
                stage.dialogue.type = deltastage.dialogue.type
                stage.dialogue.data = deltastage.dialogue.data
                stage.dialogue.portraitScene = deltastage.dialogue.portraitScene
                // stage.dialogue.tags = deltastage.dialogue.tags

                // stage.dialogue.characters = stage.dialogue.characters || {}
                // stage.dialogue.characters[stage.dialogue.speakingCharacter] = stage.dialogue.characters[stage.dialogue.speakingCharacter] || {}
                // stage.dialogue.characters[stage.dialogue.speakingCharacter].tags = stage.dialogue.characters[stage.dialogue.speakingCharacter].tags || {}
                // Objdict.forEach(deltastage.dialogue.tags, (value, key) => {
                //     if(key == "_") return
                //     stage.dialogue.characters[stage.dialogue.speakingCharacter].tags[key] = value
                // })
            }
            if(deltastage.dialogue === undefined) {
                delete stage.dialogue
            }
            if(deltastage.currentEncounterKey !== undefined) {
                stage.currentEncounterKey = deltastage.currentEncounterKey
            }
            if(deltastage.activeEncounterKeys !== undefined) {
                stage.activeEncounterKeys = deltastage.activeEncounterKeys
            }

            if(deltastage.flag != undefined) {
                stage.flags[deltastage.flag.key] = deltastage.flag.value
            }
            if(deltastage.flags != undefined) {
                stage.flags = Objdict.merge(stage.flags, deltastage.flags)
            }
            // DELTA SCHEMA v1 - a full stage object. only supported relative values.
            if(deltastage.actionMark != undefined) {
                stage.actionMark = deltastage.actionMark
            }
            // if(deltastage.light != undefined) {
            //     stage.light = deltastage.light
            // }
            if(deltastage.zone != undefined) {
                stage.zone = deltastage.zone
            }
            if(deltastage.turn != undefined) {
                if(deltastage.turn.number != undefined) {
                    stage.turn.number = deltastage.turn.number
                }
                if(deltastage.turn.phase != undefined) {
                    stage.turn.phase = deltastage.turn.phase
                }
                if(deltastage.turn.affiliation != undefined) {
                    stage.turn.affiliation = deltastage.turn.affiliation
                }
            }

            // THESE DELTA EDITS ARE ONLY REALLY INTENDED
            // FOR MAP GENERATION, AND ARE _NOT_ MEANT FOR
            // USE WITH ACTUAL GAMEPLAY, WHICH IS WHY THEY
            // JUST NUKE THE ENTIREY OF .ENCOUNTERS OR .SPOTS
            if(deltastage.encounters != undefined) {
                stage.encounters = deltastage.encounters
                if(stage.world != undefined) {
                    stage.world.zones = deltastage.encounters
                }
            }
            if(deltastage.spots != undefined) {
                if(stage.world != undefined) {
                    stage.world.spots = deltastage.spots
                }
            }
            if(deltastage.images != undefined) {
                stage.images = deltastage.images
            }
        })
        return stage
    }
}


// // TODO: also shadow the tiles
// action.shadowtiles = clonedeep(action.shadowtiles)
// if(action.results != undefined) {
//     Object.keys(action.results).forEach((key) => {
//         const result = action.results[key]
//         if(key.substring(0, 5) === "tile:") {
//             const tile = action.shadowtiles.find((tile) => tile.key == key.substring(5))
//             if(tile != undefined) {
//                 return
//             }
//             tile.isBurning = result.isBurning
//             return
//         }
//         // else is unit!!
//     })
// }

// // USED TO BE IN THE ATTACK BEAT PERFORMANCE
// if(key.substring(0, 5) == "tile:") {
//     let position = key.substring(5)
//     let tile = model.game.chapter.stage.map.tiles[position]
//     if(tile == undefined) {
//         return
//     }
//     tile.isBurning = result.isBurning || tile.isBurning
//     return
// }
// if(result.effects) {
//     unit.applyEffects(result.effects)
// }
// if(result.hasPerformedAction != undefined) {
//     if(result.hasPerformedAction == false) {
//         unit.hasPerformedMove = false
//         unit.hasPerformedAttack = false
//         unit.hasPerformedAction = false
//     }
// }

// if(key == "performer") {
//     unit = stage.findUnitByKey(action.performer.key)
// } else if(key == "target") {
//     unit = stage.findUnitByKey(action.target.key)
// }
